module.exports = __webpack_public_path__ + "img/sports.97cc5f7f.png";